<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">

        <li v-if="$store.state.organization.id" class="nav-title">
          <div class="dropdown">
            <span><img :src="logo" class="client-logo"/></span>
            <div class="dropdown-content" v-for="(org, index) in $store.state.linked_organizations">
              <p><a :href="'/dashboard/'+ org.id"><img :src="org.logo" class="client-logo"/></a></p>
            </div>
          </div>
        </li>

<!--
        <div v-if="$store.state.organization._reports && $store.state.sections && $store.state.sections.reports && $store.state.sections.reports.read" >
          <div  v-tooltip="'Analytics'" >
            <router-link :to="'/reports/'+ $store.state.organization.id" class="btn btn-primary w-100 h-100 mt-2"  ><i class="fas fa-chart-line"></i>&nbsp;&nbsp;Analytics</router-link>
-->
        <div v-for="(sec, index) in sections" >
          <div  v-tooltip="sec['label']" >
            <router-link :to="'/'+ sec['path'] + '/' + sec['org_id'] " class="btn btn-primary w-100 h-100 mt-2"  ><i :class="'fas ' + sec['icon']"></i>&nbsp;&nbsp;{{sec['label']}}</router-link>
          </div>
        </div>

      </ul>
    </nav>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import {db} from '../firebase'
/* eslint-disable */
export default {
  name: 'sidebar',
  created: function() {
    let ref = db.ref('/Sections')
    ref.once('value', snapshot => {
      if (snapshot.val()) {
        this.globalSections = snapshot.val()
        if (this.$store.state.sections) {
          for (var sec in this.$store.state.sections) {
            let obj = this.$store.state.sections[sec]
            if (obj.read == true) {
              let icon = this.globalSections[sec]['icon']
              let label = this.globalSections[sec]['label']
              this.sections.push({"label": label,"icon": icon, "path": sec, "org_id": this.$store.state.organization.id })
            }
          }
          this.sections.sort((a, b) => {
            return a.label > b.label
          })
        }
      }
    })
  },
  data: function () {
    return {sections:[], globalSections:{}}
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      jQuery('.sidebar-link').removeClass('active-sidebar')
      jQuery(e.target).closest('.sidebar-link').toggleClass('active-sidebar')
    }
  },
  props: ['logoUrl'],
  computed: mapState({
      logo: state => state.organization.logo
  })

}
</script>

<style lang="css">
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: relative;
    background-color: #1985ac;
    min-width: 100%;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    padding: 2px 10px;
    z-index: 1;
}

.dropdown:hover .dropdown-content {
    display: block;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?4f5e1d0c